export const ADDRESS_SEARCH_TERM_SET = 'ADDRESS_SEARCH_TERM_SET';
export const ADDRESS_SEARCH_RESULTS_CLEAR = 'ADDRESS_SEARCH_RESULTS_CLEAR';
export const ADDRESS_SEARCH_RESULT_SELECTED = 'ADDRESS_SEARCH_RESULT_SELECTED';
export const ADDRESS_SEARCH_REQUESTED = 'ADDRESS_SEARCH_REQUESTED';
export const ADDRESS_SEARCH_RESOLVED = 'ADDRESS_SEARCH_RESOLVED';
export const ADDRESS_SEARCH_ERROR = 'ADDRESS_SEARCH_ERROR';
